<template lang="pug">
    v-sheet(color="grey lighten-4")
        v-tabs(v-model='tab' background-color='grey darken-2' dark show-arrows)
            v-tabs-slider()
            v-tab() Открытые
            v-tab() Закрытые
        v-tabs-items(v-model='tab' color="transparent" touchless)
            v-tab-item()
                v-sheet(color="grey lighten-4")
                    v-container(fluid).pa-0
                        v-skeleton-loader(type='table' v-if="loading")
                        v-card(v-if="!loading")
                            portfolio-history-open(:deals="client.clientDeals.open")
            v-tab-item
                v-sheet(color="grey lighten-4")
                    v-container(fluid).pa-0
                        v-skeleton-loader(type='table' v-if="loading")
                        v-card(v-if="!loading")
                            portfolio-history-closed(:deals="client.clientDeals.closed")
</template>

<script>
    import { mapGetters } from 'vuex';
    import  { mapState } from 'vuex';
    import PortfolioHistoryOpen from "@/components/PortfolioHistoryOpen";
    import PortfolioHistoryClosed from "@/components/PortfolioHistoryClosed";

    export default {
        name: "PortfolioHistory",
        components: {
            'portfolio-history-open': PortfolioHistoryOpen,
            'portfolio-history-closed': PortfolioHistoryClosed
        },
        computed: {
            ...mapState([
                'client'
            ]),
            ...mapGetters([
                'open_symbols',
                'closed_symbols',
            ]),
        },
        data () {
            return {
                loading: true,
                page_name: 'Сделки',
                tab: null,
                headerProps: {
                    sortByText: "Упорядочить по"
                },

                portfolioHistoryClosedTableHeaders: [
                    {
                        text: 'Дата',
                        align: 'start',
                        sortable: true,
                        value: 'date_buy',
                        fixed: true,
                        width: '140px',
                    },
                    {
                        text: 'Действие',
                        align: 'start',
                        sortable: false,
                        value:'action'
                    },
                    {
                        text: 'Название',
                        sortable: true,
                        value: 'symbol.full_name',
                        width: '300px'
                    },
                    { text: 'Тикер', value: 'symbol.short' },
                    { text: 'Цена акции', value: 'buy_cost' },
                    { text: 'Количество', value: 'count' },
                    { text: 'Общая комиссия', value: 'commission.buy'},
                    { text: 'Сумма с комиссией клиента', value: 'get_deal_cost_info.deal_cost_buy'},
                ],
                open_symbols_list: [],
                closed_symbols_list: [],
                open_deals_filters: {
                    dates:{
                        from: null,
                        to: null,
                    },
                    search:''
                },

            }
        },
        methods: {
        },
        created () {
            this.$store.commit('setCurrentViewName', this.page_name)
            this.$store.dispatch('getClientDeals', this.$store.state.auth.user.id)
                .then( () => {
                    this.loading = false
                    this.open_symbols_list = this.symbols
                    this.closed_symbols_list = this.symbols
                })
        }
    }
</script>

<style scoped>

</style>
